// extracted by mini-css-extract-plugin
export default {"container":"AuctionForm_container__3vNBL","confirm":"AuctionForm_confirm__I8OLU"};